// Badge, Kbd and Pips — the small inline marks.
import type { ReactNode } from 'react';

export type BadgeTone = 'red' | 'amber' | 'green' | 'gold' | 'grey' | 'plum' | 'blue';

export function Badge({ tone = 'gold', filled, pulse, children, label, title, className = '' }: { tone?: BadgeTone; filled?: boolean; pulse?: boolean; children: ReactNode; label?: string; title?: string; className?: string }) {
  return <span className={`fk-badge fk-badge--${tone} ${filled ? 'fk-badge--filled' : ''} ${pulse ? 'fk-badge--pulse' : ''} ${className}`} aria-label={label} title={title}><span>{children}</span></span>;
}

export function Kbd({ children }: { children: ReactNode }) { return <kbd className="fk-kbd">{children}</kbd>; }

/** Five dots for a 0–5 axis (ledger regard, slot fill); values above five print `+n`. */
export function Pips({ value, max = 5, label, lock, className = '' }: { value: number; max?: number; label?: string; /** indices (0-based) drawn green as "committed" */ lock?: ReadonlySet<number> | number[]; className?: string }) {
  const n = Math.min(max, Math.max(0, value));
  const locks = lock ? new Set(lock) : undefined;
  const text = `${label ? `${label} ` : ''}${value}`;
  return (
    <span className={`fk-pips ${className}`} title={text} aria-label={text} role="img">
      {label && <span className="fk-pips__label">{label}</span>}
      {Array.from({ length: max }, (_, i) => <span key={i} className={`fk-pips__dot ${locks?.has(i) ? 'fk-pips__dot--lock' : i < n ? 'fk-pips__dot--on' : ''}`} />)}
      {value > max && <span className="fk-pips__more">+{value - max}</span>}
    </span>
  );
}

/** §14: the board announces the selected hero's plan as text via a live region. */
export function LiveRegion({ text }: { text: string }) {
  return <div className="fk-visually-hidden" role="status" aria-live="polite" aria-atomic="true">{text}</div>;
}
